import { ArrowDown, ArrowUp } from 'lucide-react';

interface EICharacteristicAspectProps {
    isHighDescriptor: boolean;
    descriptor: string;
}

function EICharacteristicAspect({ isHighDescriptor, descriptor }: EICharacteristicAspectProps) {
    return (
        <>
            <div className="col-span-2 flex justify-center">
                {isHighDescriptor ? (
                    <ArrowUp className="size-5 text-green-600" aria-hidden />
                ) : (
                    <ArrowDown className="size-5 text-red-600" aria-hidden />
                )}
            </div>
            <div className="col-span-8 pb-3">
                <p className="text-sm break-words">{descriptor}</p>
            </div>
            <div className="col-span-2" />
        </>
    );
}

export default EICharacteristicAspect;
